import Header from './components/Header';
import Hero from './components/Hero';
import Comments from './components/Comments';
import About from './components/About';
import Faq from './components/Faq';
import Carousel from './components/Carousel';
import Cards from './components/Cards';
import AppSection from './components/AppSection';
import Contact from './components/Contact';
import Updates from './components/Updates';
import Ranking from './components/Ranking';
import Index from './components/Index';
import Topics from './components/Topics';
import Features from './components/Features';
import Media from './components/Media';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Comments />
        <About />
        <Faq />
        <Carousel />
        <Cards />
        <AppSection />
        <Contact />
        <Updates />
        <Ranking />
        <Index />
        <Topics />
        <Features />
        <Media />
      </main>
      <Footer />
    </>
  );
}